import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BrainIcon, CalendarDaysIcon, Dice5Icon, MessageCircleIcon, PaletteIcon, PersonStandingIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { categories, type Category } from '../data/megaPack';
import { useIsMobile } from '../hooks/useMediaQuery';
const iconMap: Record<Category['icon'], typeof BrainIcon> = {
  brain: BrainIcon,
  dice: Dice5Icon,
  move: PersonStandingIcon,
  chat: MessageCircleIcon,
  palette: PaletteIcon,
  sparkles: SparklesIcon,
  calendar: CalendarDaysIcon
};
export function Categories() {
  const isMobile = useIsMobile();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const active = categories[activeIndex];
  const ActiveIcon = iconMap[active.icon];
  return <section className="bg-cream-50 py-10 sm:py-20" aria-labelledby="actividades-incluidas" data-id="element-30" data-mp="1xu9z11ntlv1e">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-31" data-mp="1t0p5pmx69p8j">
        <SectionHeading eyebrow="Actividades incluidas" title="Todo tipo de propuesta, ya clasificada" subtitle="Elegís la categoría según el momento del día, las ganas y las posibilidades de cada persona." data-id="element-32" data-mp="364h242w97hk2" />

        {isMobile ? <div className="mt-6" data-id="element-33" data-mp="2wdcu5n4zwwyq">
            <div className="flex flex-wrap justify-center gap-2" data-id="element-34" data-mp="31difymol3p8w">
              {categories.map((category, index) => {
            const Icon = iconMap[category.icon];
            const isActive = index === activeIndex;
            return <button key={category.title} type="button" onClick={() => setActiveIndex(index)} aria-pressed={isActive} className={['flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-600 transition-colors duration-150 ease-out', isActive ? 'bg-teal-800 text-cream-50' : 'bg-teal-50 text-teal-700 ring-1 ring-teal-700/15'].join(' ')} data-id="element-35" data-mp="2rdrm8n7ule9v" data-mpi={index}>
                    <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" data-mp="a6hutflrqmfz" />
                    {category.title}
                  </button>;
          })}
            </div>

            <AnimatePresence mode="wait" data-id="element-37" data-mp="b6e4rqsv55l">
              <motion.div key={active.title} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -4
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-4 flex gap-3 rounded-2xl bg-teal-50 p-4" aria-live="polite" data-id="element-38" data-mp="xxds2s8zu9um">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-teal-100" data-id="element-39" data-mp="1gnv6drt2x2wg">
                  <ActiveIcon className="h-4 w-4 text-teal-700" aria-hidden="true" data-id="element-40" data-mp="1bxeuwd8tjrcq" />
                </span>
                <div data-id="element-41" data-mp="1k6atsx7pdwv9">
                  <h3 className="font-display text-sm font-800 uppercase tracking-wide text-teal-900" data-id="element-42" data-mp="1k6ubcctfyj8r">
                    {active.title}
                  </h3>
                  <p className="mt-1 text-[0.8rem] leading-relaxed text-clay" data-id="element-43" data-mp="1t6h46a83ugq7">
                    {active.description}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div> : <div className="mt-12 grid gap-x-8 gap-y-9 sm:grid-cols-2 lg:grid-cols-3" data-id="element-44" data-mp="233vkm9u135ii">
            {categories.map(category => {
          const Icon = iconMap[category.icon];
          return <article key={category.title} className="flex gap-4" data-id="element-45" data-mp="2bxid9r2xvsnh">
                  <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-100" data-id="element-46" data-mp="2gwbgmqoii39x">
                    <Icon className="h-5 w-5 text-teal-700" aria-hidden="true" data-id="element-47" data-mp="2lwfusa1y6lwz" />
                  </span>
                  <div data-id="element-48" data-mp="2qur66p7w54hb">
                    <h3 className="font-display text-base font-800 uppercase tracking-wide text-teal-900" data-id="element-49" data-mp="2qs4x2l5cqgwz">
                      {category.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-clay" data-id="element-50" data-mp="3im08b39f58qi">
                      {category.description}
                    </p>
                  </div>
                </article>;
        })}
          </div>}
      </div>
    </section>;
}